export const INPUT_MASKS = {
  phone: '+9 999 999 99 99',
  phoneWithPrefix: '+7\\ 999 999 99 99',
  date: '99.99.9999',
};
